{
  "fallback": {
    "400": "入力内容に正しくないものがあります — 確認してください",
    "401": "もう一度ログインしてください",
    "403": "この操作を行う権限がありません",
    "404": "見つかりませんでした — 削除された可能性があります",
    "409": "他の変更とぶつかりました — 再読み込みしてもう一度お試しください",
    "410": "期限が切れています",
    "413": "大きすぎます",
    "422": "入力内容に不足や誤りがあります",
    "423": "一時的にロックされています — しばらくしてからお試しください",
    "428": "保存する前に最新の内容を読み込んでください",
    "429": "操作が多すぎます — 少し待ってからお試しください",
    "5xx": "システム側で問題が発生しました — 少ししてからお試しください",
    "network": "お店のシステムに接続できません — インターネット接続を確認してください",
    "unknown": "問題が発生しました"
  },
  "field": {
    "required": "{{label}}を入力してください",
    "must_be_positive": "{{label}}は0より大きくしてください",
    "greater_than": "{{label}}は{{limit}}より大きくしてください",
    "greater_than_equal": "{{label}}は{{limit}}以上にしてください",
    "less_than": "{{label}}は{{limit}}より小さくしてください",
    "less_than_equal": "{{label}}は{{limit}}以下にしてください",
    "too_short": "{{label}}が短すぎます",
    "too_long": "{{label}}が長すぎます",
    "too_long_limit": "{{label}}が長すぎます（{{limit}}まで）",
    "pattern": "{{label}}の形式が正しくありません",
    "whole_number": "{{label}}は整数で入力してください",
    "number": "{{label}}は数字で入力してください",
    "choice": "{{label}}：選択肢から選んでください",
    "email": "{{label}}：メールアドレスの形式ではありません",
    "date": "{{label}}：正しい日付ではありません",
    "invalid": "{{label}}が正しくありません"
  },
  "hints": {
    "status": {
      "401": "もう一度ログインしてください — 入力した内容は下書きとして残ります。",
      "403": "オーナーにこの権限の付与を依頼してください。",
      "409": "再読み込みして最新の内容を確認してから、もう一度行ってください。",
      "422": "赤く表示された項目を直して、もう一度保存してください。",
      "429": "1分ほど待ってからお試しください。",
      "5xx": "1分後にもう一度お試しください。続く場合は参照コードをコピーしてオーナーに送ってください。",
      "network": "Wi-Fiやモバイル通信を確認してください。下書きのあるフォームは接続が戻ると保存されます。"
    },
    "codes": {
      "version_conflict": "最新の内容を読み込んで変更点を確認するか、自分の内容で上書き保存してください。",
      "insufficient_stock": "商品ページで在庫を確認してください — 店頭かネットで売れた可能性があります。",
      "oversell_conflict": "二重販売の画面を開き、どちらにカードを渡すか選んでください。",
      "tax_evidence_missing": "注文を開いて輸出の証拠（送り状や税関書類）を追加してください。",
      "raw_rank_required": "このカードのランクA・B・C・Dを選んでください。",
      "price_below_cost": "価格を確認してください — 仕入れ値より低くなっています。",
      "reason_required": "「破損」「数え直し」などの短い理由を入力してください。",
      "account_locked": "表示された時間まで待つか、オーナーにロック解除を依頼してください。",
      "issuer_registration_missing": "設定 → 税金 で店のT番号を入力してください。",
      "order_not_paid": "入金を確認したら先に ①入金確認 を押してください。",
      "identity_check_required": "先にこの方の本人確認をしてください。",
      "payment_has_funds": "先に入金確認をしてから、返金でお返ししてください。",
      "manager_approval_required": "この画面で店長に承認してもらってください。",
      "manager_pin_required": "店長にPINを入力してもらってください。",
      "taxfree_training_required": "オーナーに相談してください — 免税販売は研修を受けたスタッフのみです。"
    }
  },
  "codes": {
    "validation_failed": "入力内容に不足や誤りがあります — 赤く表示された項目を確認してください",
    "invalid_reference": "参照しているデータがもう存在しません — 再読み込みして選び直してください",
    "invalid_cursor": "一覧のページが古くなりました — 最初のページに戻ってください",
    "unauthorized": "もう一度ログインしてください",
    "token_expired": "ログインの有効期限が切れました — もう一度ログインしてください",
    "forbidden": "この操作を行う権限がありません",
    "not_found": "見つかりませんでした — 削除された可能性があります",
    "method_not_allowed": "ここではこの操作はできません",
    "conflict": "他の変更とぶつかりました — 再読み込みしてもう一度お試しください",
    "version_conflict": "あなたより先に他の人がこの内容を変更しました",
    "idempotency_key_required": "安全に送信できませんでした — もう一度お試しください",
    "if_match_required": "保存する前に最新の内容を読み込んでください",
    "idempotency_conflict": "別の内容ですでに送信されています — 再読み込みして確認してください",
    "payload_too_large": "データが大きすぎて送れません — 小さくしてください",
    "rate_limited": "短時間に操作が多すぎます — 少し待ってからお試しください",
    "feature_disabled": "この機能はまだオンになっていません",
    "invalid_state_transition": "今の状態ではこの操作はできません",
    "upstream_unavailable": "システムの一部が応答していません — しばらくしてからお試しください",
    "internal_error": "システム側で問題が発生しました",
    "insufficient_stock": "この商品はもう在庫がありません",
    "unit_not_available": "このカードはもう販売できません",
    "hold_not_found": "取り置きが見つかりません",
    "hold_expired": "取り置きの期限が切れました",
    "oversell_conflict": "このカードは別の販売先で売れました",
    "location_not_allowed": "この店舗・倉庫での作業は許可されていません",
    "hold_not_active": "この取り置きはもう有効ではありません",
    "unit_already_sold": "このカードはすでに売れています",
    "reason_required": "この変更には理由の入力が必要です",
    "location_inactive": "この店舗・倉庫は使用停止中です",
    "location_has_stock": "この店舗・倉庫にはまだ在庫があります",
    "location_is_default": "メインの店舗・倉庫は停止できません",
    "hold_type_not_allowed": "1点ものカードにはこの種類の取り置きはできません",
    "hold_extension_limit": "この取り置きはこれ以上延長できません",
    "use_unit_action": "1点ものカードは数量ではなく1枚ずつ調整してください",
    "not_consigned": "このカードは委託品ではありません",
    "unit_on_hold": "このカードは取り置き中です — 移動する前に取り置きを解除してください",
    "stream_capacity_reached": "現在接続が混み合っています — 少しお待ちください",
    "conflict_not_open": "この二重販売はすでに解決済みです",
    "unit_already_in_show": "このカードはすでにライブ配信に入っています",
    "raw_rank_missing": "このカードにはランクがありません — ラベル印刷の前にランク（A/B/C/D）を設定してください",
    "discrepancy_not_open": "この在庫差異はすでに処理済みです",
    "discrepancy_manual_fix": "この在庫差異は1枚ずつ直す必要があります — 表示された対応をご確認ください",
    "sale_not_voidable": "この販売はもう取り消せません — 返品として受け付けてください",
    "return_exceeds_sale": "販売した数より多く戻そうとしています",
    "raw_rank_required": "未鑑定カードにはランク（A/B/C/D）が必要です",
    "handle_recently_used": "このURLは最近使われました — 別のものを選んでください",
    "compare_at_evidence_missing": "「通常価格」には根拠（8週間の販売実績またはメーカー価格）が必要です",
    "duplicate_set": "同じコードと言語のセットがすでにあります",
    "duplicate_card": "このカードはすでにセットに登録されています",
    "in_use": "まだ商品で使われているため変更できません",
    "not_enabled": "この機能はまだオンになっていません",
    "unknown_attribute": "不明な項目です",
    "invalid_attribute": "項目の値が正しくありません",
    "category_cycle": "カテゴリを自分自身の下に入れることはできません",
    "category_too_deep": "カテゴリは3階層までです",
    "graded_fields_required": "鑑定品には鑑定会社・グレード・証明書番号が必要です",
    "condition_type_mismatch": "状態の種類が商品の種類と合っていません",
    "invalid_grade": "グレードは1〜10の0.5刻みで入力してください",
    "invalid_raw_rank": "ランクはA・B・C・Dのいずれかです",
    "invalid_cert_format": "証明書番号がこの鑑定会社の形式と合いません",
    "price_below_cost": "価格が仕入れ値を下回っています",
    "legacy_condition_alias_rejected": "NM/LP/MP/HP/DMGではなく店のランクA/B/C/Dを使ってください",
    "weight_required": "未開封商品には重さが必要です",
    "duplicate_sku": "この商品コードはすでに使われています",
    "invalid_ean": "バーコードが正しいJAN/EAN-13番号ではありません",
    "reserved_handle": "このURLは予約されています — 別のものを選んでください",
    "compare_at_type_not_allowed": "この商品にはこの種類の「通常価格」の根拠は使えません",
    "export_price_low": "海外向け価格が税抜の店頭価格よりかなり低くなっています",
    "channel_not_enabled": "この販売先はまだオンになっていません",
    "last_variant": "商品には最低1つの種類（状態・価格）が必要です",
    "variant_in_use": "この種類にはまだ在庫や販売があります — 代わりに商品をアーカイブしてください",
    "too_many_variants": "一度に保存する種類が多すぎます — 分けて保存してください",
    "restore_window_expired": "この商品は削除から30日以上たっているため元に戻せません",
    "duplicate_cert": "この証明書番号のカードはすでに登録されています",
    "duplicate_barcode": "このバーコードは別の商品で使われています",
    "similar_product_exists": "同じカード・同じ状態の商品がすでにあります",
    "too_many_media": "商品の写真は最大10枚です",
    "media_not_in_product": "この商品の写真の中から選んでください",
    "media_failed": "写真を処理できませんでした",
    "no_media": "商品にまだ写真がありません",
    "publish_blocked": "まだ公開できません — チェックリストの項目を直してください",
    "invalid_rule": "自動コレクションの条件に正しくないものがあります",
    "collection_is_smart": "自動コレクションの商品は条件で決まります",
    "file_too_large": "ファイルが大きすぎます",
    "unknown_columns": "ファイルに知らない列があります",
    "missing_columns": "ファイルに必要な列がありません",
    "too_many_rows": "ファイルの行数が多すぎます",
    "invalid_file_encoding": "ファイルを読めませんでした — 「CSV UTF-8」で保存してください",
    "import_has_errors": "エラーのある行があります — 直すか、スキップを選んでください",
    "unknown_csv_profile": "ファイルの種類がわかりません — 見本ファイルから始めてください",
    "currency_not_jpy": "このファイルの価格は日本円である必要があります — 通貨を確認してください",
    "export_not_ready": "書き出しファイルはまだ準備中です",
    "export_expired": "この書き出しファイルは期限切れです — もう一度書き出してください",
    "variant_not_found": "このコードに合う商品がありません",
    "unsupported_media_type": "この種類のファイルは使えません — JPEG・PNG・WebP・HEIC・GIF・PDFを使ってください",
    "upload_quota_exceeded": "今日のアップロード上限に達しました — 明日またお試しください",
    "upload_not_received": "ファイルがまだ届いていません — もう一度アップロードしてください",
    "restricted_upload_required": "身分証や振込明細は専用の安全なアップロードを使ってください",
    "purpose_not_allowed": "この種類のファイルはここにはアップロードできません",
    "upload_session_not_open": "この撮影は終了しています — パソコンで新しく始めてください",
    "upload_session_full": "この撮影は枚数の上限に達しました",
    "handoff_token_invalid": "このQRコードは期限切れです — パソコンで新しいものを表示してください",
    "media_restore_expired": "このファイルは削除から時間がたちすぎているため元に戻せません",
    "storage_unavailable": "ファイル保管庫に接続できません — しばらくしてからお試しください",
    "restricted_link_invalid": "この閲覧リンクは期限切れか使用済みです — もう一度ファイルを開いてください",
    "retention_shorten_forbidden": "このファイルの保管期限は延ばすことしかできません",
    "document_data_inconsistent": "書類の金額が合わないため発行しませんでした",
    "document_type_not_supported": "この種類の書類はまだ作成できません",
    "document_already_superseded": "この書類はすでに訂正版に置き換わっています — 最新のものを使ってください",
    "document_render_failed": "今は書類を作成できません — 自動でもう一度試します",
    "recipient_name_required": "適格請求書には宛名が必要です",
    "issuer_registration_missing": "店の登録番号（T番号）がまだ設定されていません",
    "customs_data_incomplete": "印刷の前に、すべての商品の重さ・HSコード・金額を入力してください",
    "document_issuer_incomplete": "書類に載せる店名と住所がまだ設定されていません",
    "document_source_unsupported": "この記録からはこの書類を作れません",
    "order_not_payable": "この注文は支払いできません",
    "payment_method_unavailable": "この支払い方法は使えません",
    "payment_already_captured": "この支払いはすでに確定しています",
    "amount_mismatch": "金額が一致しません",
    "cart_not_found": "カートが見つかりません — 新しく始めてください",
    "cart_line_not_found": "この商品はカートに入っていません",
    "cart_line_limit": "カートがいっぱいです — 先に商品を減らしてください",
    "product_unavailable": "この商品はネットでは買えません",
    "discount_not_found": "この割引コードはありません",
    "discount_expired": "この割引コードは期限切れです",
    "discount_not_started": "この割引コードはまだ使えません",
    "discount_usage_exhausted": "この割引コードは使用回数の上限に達しました",
    "discount_min_subtotal": "カートの合計がこのコードの最低金額に届いていません",
    "discount_channel": "この割引コードはここでは使えません",
    "discount_no_eligible_lines": "カートの中にこの割引コードを使える商品がありません",
    "shipping_unavailable": "この住所には発送できません",
    "too_heavy": "荷物が重すぎて、使える配送方法がありません",
    "address_required": "先にお届け先の住所が必要です",
    "shipping_rate_invalid": "この送料設定は正しくありません",
    "shipping_zone_conflict": "この国・都道府県はすでに別の配送エリアに入っています",
    "ddp_required": "アメリカ宛てはDDP（関税を店が支払う）である必要があります",
    "pickup_location_invalid": "この店舗では店頭受け取りをしていません",
    "postal_code_not_found": "この郵便番号は見つかりません",
    "inventory_unavailable": "今は在庫を確認できません",
    "catalog_unavailable": "今は商品情報を読み込めません",
    "tax_unavailable": "今は税金を計算できません",
    "secondhand_license_required": "古物商許可（公安委員会と許可番号）が「設定 → ショップ情報」に保存されるまで、買取と委託受付は停止しています。",
    "web_orders_paused": "現在、サイトの注文受付を一時停止しています（設定 → 購入手続き）。店頭レジには影響ありません。",
    "discount_type_not_supported": "この種類の割引はまだ使えません",
    "cart_empty": "カートが空です — 先に商品を入れてください",
    "checkout_not_found": "この購入手続きが見つかりません",
    "checkout_expired": "注文手続きの時間が切れました — カートからやり直してください",
    "checkout_already_placed": "この注文はすでに確定しています",
    "checkout_incomplete": "注文を確定する前に、まだ入力されていない項目があります",
    "totals_changed": "合計金額が変わりました — 新しい金額を確認して、もう一度確定してください",
    "return_policy_ack_required": "返品特約を読んだことを確認してください",
    "tokusho_ack_required": "注文内容（特定商取引法に基づく表示）を確認してください",
    "ddp_notice_ack_required": "この国宛ての関税のご案内を確認してください",
    "payment_method_invalid": "この注文にはこの支払い方法を使えません — 別の方法を選んでください",
    "payments_unavailable": "今は支払いの準備ができません",
    "identity_unavailable": "今はお客様情報を保存できません",
    "order_not_found": "この注文は見つかりません",
    "order_number_format_locked": "注文があるため、注文番号の形式は変更できません",
    "order_not_pending_payment": "この注文はもう入金待ちではありません",
    "method_mismatch": "この注文は銀行振込ではないため、ここで報告するものはありません",
    "payment_not_found": "この注文の支払いが見つかりません",
    "nothing_to_resolve": "精算が必要な支払いの差額はありません",
    "order_not_paid": "まだ入金されていません — 先に入金確認をしてください",
    "order_under_review": "この注文は準備の前に店長の承認が必要です",
    "invalid_transition": "今の時点ではこの手順はできません",
    "undo_window_passed": "この手順を元に戻せる時間が過ぎました — 店長がメモ付きで戻せます",
    "insurance_required": "高額な荷物には全額補償と受け取りサインが必要です",
    "fulfillment_not_found": "この発送は見つかりません",
    "order_not_shipped": "この注文はまだ何も発送していません",
    "tracking_edit_window_passed": "追跡番号を直せるのは発送から24時間以内です",
    "pickup_qr_invalid": "この受け取りコードに合う注文はありません",
    "carrier_unknown": "不明な配送会社です",
    "tracking_format_invalid": "追跡番号がこの配送会社の形式と合いません",
    "tracking_url_invalid": "追跡リンクは配送会社の公式ページである必要があります",
    "zonos_declaration_required": "アメリカ宛ての荷物にはZonosの申告ID（関税前払い）が必要です",
    "declared_value_mismatch": "税関への申告額は実際の販売価格にしてください",
    "order_not_editable": "この注文はもう変更できません",
    "order_line_not_found": "この商品はこの注文に入っていません",
    "use_return_flow": "商品はすでに発送済みです — キャンセルではなく返品にしてください",
    "order_already_cancelled": "この注文はすでにキャンセルされています",
    "final_sale": "カードは返品不可です — 破損・誤送・説明と違う場合のみ返品できます",
    "return_window_passed": "この商品の返品期限は過ぎています",
    "return_not_allowed": "この理由ではこの商品を返品できません",
    "return_not_found": "この返品は見つかりません",
    "return_already_open": "この商品にはすでに返品手続きがあります",
    "return_invalid_state": "この返品では今この手順はできません",
    "document_already_issued": "この書類はすでに発行済みです — 書類画面から訂正してください",
    "provider_disabled": "この支払い方法はまだオンになっていません",
    "payment_not_pending": "この支払いはもう入金待ちではありません",
    "method_not_allowed_for_channel": "ここではこの支払い方法は使えません",
    "refund_exceeds_captured": "返金額が、支払われてまだ返金していない金額より大きいです",
    "store_credit_insufficient": "ストアクレジットが足りません",
    "store_credit_expiry_exceeds_policy": "ストアクレジットの有効期限は最長6か月です",
    "customer_required": "これにはお客様アカウントが必要です",
    "surcharge_disabled_by_default": "カード手数料をお客様に請求すると、カード会社や端末の契約に違反するおそれがあります — カード会社に確認してからオンにしてください",
    "brand_not_supported": "このカード端末はこのブランドに対応していません",
    "payment_method_in_use": "この方法で入金待ちの支払いがあります — 先に完了するかキャンセルしてください",
    "insufficient_tender": "お預かりした現金が金額に足りません",
    "edc_duplicate_approval": "このカード承認番号は今日すでに記録されています",
    "four_eyes_required": "依頼した内容は別の店長の承認が必要です",
    "refund_method_not_allowed": "この支払いはこの方法では返金できません",
    "payment_has_funds": "この支払いはすでに入金されています — キャンセルではなく入金確認してから返金してください",
    "tax_evidence_missing": "輸出の証拠書類がありません",
    "tax_free_not_eligible": "免税の対象ではありません",
    "tax_free_threshold_not_met": "免税の最低金額に届いていません",
    "discount_exceeds_total": "割引が割引可能な合計より大きいです",
    "discount_line_unknown": "割引の対象が書類の明細にありません",
    "taxfree_web_not_allowed": "免税販売は店頭でのみできます",
    "taxfree_mixed_receipt": "免税のレシートに対象外の商品が入っています — レシートを分けてください",
    "taxfree_detail_required": "高額な免税品には商品の詳細とシリアル番号が必要です",
    "taxfree_not_licensed": "店に輸出物品販売場の許可がありません",
    "commission_outside_settlement": "手数料の明細は精算書にのみ入れられます",
    "calculation_not_found": "この書類の税計算が保存されていません",
    "invalid_registration_number": "登録番号は「T」と13桁の数字です",
    "field_locked": "この設定は固定されていて、ここでは変更できません",
    "wari2_ended": "2割特例は2026年9月30日を含む課税期間で終了しました",
    "wari3_not_allowed": "3割特例は2027〜2028年の個人事業者だけが使えます",
    "simplified_taxation_dates_required": "簡易課税には開始日と終了日が必要です",
    "effective_from_too_early": "適用開始日は今日（書類がまだない場合）以降にしてください",
    "rounding_change_period_boundary": "端数処理の変更は次の課税期間から適用されます",
    "append_only": "設定の履歴は変更できません — 新しい版を作ってください",
    "settings_version_not_found": "この税設定の版は見つかりません",
    "legal_calendar_event_not_found": "この法令カレンダーの予定は見つかりません",
    "source_url_required": "法令の日付を変えるときは出典のURLが必要です",
    "market_not_found": "この販売地域は見つかりません",
    "market_exists": "このコードの販売地域はすでにあります",
    "market_country_conflict": "1つの国は1つの販売地域にしか入れません",
    "market_protected": "この販売地域は削除・停止できません",
    "fx_rate_not_found": "為替レートが見つかりません",
    "fx_rate_unavailable": "この通貨の為替レートがありません",
    "mrz_invalid": "パスポートを読み取れませんでした — 下の2行をもう一度読み取ってください",
    "verification_not_found": "免税の確認が見つかりません",
    "verification_expired": "免税の確認の期限が切れました — パスポートをもう一度読み取ってください",
    "verification_consumed": "この免税の確認はすでにレシートで使われています",
    "calc_mismatch": "金額がこの書類の保存された税計算と合いません",
    "already_confirmed": "税関がすでにこの記録を確認したため、変更できません",
    "taxfree_record_not_found": "免税の記録が見つかりません",
    "taxfree_record_cancelled": "この免税の記録は取り消されています",
    "export_batch_not_found": "書き出しのまとまりが見つかりません",
    "export_batch_empty": "この期間に書き出す免税の記録はありません",
    "transmission_not_retryable": "この送信は今は再送できない状態です",
    "already_final": "この免税の記録の税関結果はすでに記録されています",
    "customs_not_applicable": "この免税の記録は税関の確認待ちではありません",
    "nta_api_not_enabled": "国税庁との接続はまだオンになっていません — 税関の結果はファイルで取り込んでください",
    "customs_import_invalid": "税関の結果ファイルを読めませんでした",
    "taxfree_refund_not_allowed": "この記録では今は税金の返金を依頼できません",
    "export_evidence_not_found": "この注文には輸出の証拠書類がありません",
    "evidence_item_not_found": "この証拠書類は見つかりません",
    "evidence_locked": "証拠書類を削除できるのは24時間以内です — 現在は7年間保管されます",
    "evidence_not_required": "この注文にはもう輸出の証拠書類は必要ありません",
    "tax_document_not_found": "この書類の税情報がありません",
    "document_type_not_applicable": "この販売・返金ではこの種類の書類は発行できません",
    "report_range_invalid": "レポートの期間が正しくありません",
    "taxfree_training_required": "免税販売の研修を受けたスタッフだけができます",
    "calculation_locked": "この税計算は発行済みの書類に使われているため変更できません",
    "customs_after_deadline": "税関の確認が90日の期限を過ぎたため、この販売は課税のままです",
    "taxfree_payload_invalid": "購入記録が免税の送信形式に合っていません",
    "consignor_not_linked": "委託者アカウントがつながっていません",
    "identity_check_required": "本人確認が必要です",
    "consignor_suspended": "この委託者アカウントは一時停止中です — 店にお問い合わせください",
    "consignor_not_active": "委託者はまだ有効ではありません — 先に本人確認を終えてください",
    "consignor_close_blocked": "委託者のカードやお金がまだ店にあります — 先に精算してください",
    "bank_account_required": "銀行振込でのお支払いには銀行口座が必要です",
    "bank_account_invalid": "銀行口座の情報が正しくありません",
    "customer_already_linked": "このお客様アカウントはすでに別の委託者のものです",
    "payout_in_progress": "この委託者への支払いを処理中です — 終わってからもう一度お試しください",
    "agreement_locked": "この契約書の版はすでに使われています — 新しい版を公開してください",
    "agreement_already_accepted": "委託者はすでにこの版の契約に同意しています",
    "invalid_tiers": "手数料の価格帯は¥0から始め、すき間や重なりなく、最後は上限なしにしてください",
    "blocked_minor": "18歳未満の方は保護者の書面による同意がないと売却・委託できません",
    "method_not_allowed_for_remote": "この本人確認の方法は対面でのみ使えます",
    "method_not_allowed_for_face_to_face": "この本人確認の方法は郵送・オンライン取引専用です",
    "method_not_allowed_for_foreign_national": "外国籍の方は在留カードかパスポートで確認してください",
    "identity_document_expired": "身分証の有効期限が切れています",
    "identity_check_not_pending": "この本人確認はすでに確認済みか却下されています",
    "manager_approval_required": "店長の承認が必要です",
    "document_not_attachable": "このファイルは身分証の画像として使えません — もう一度アップロードしてください",
    "tax_free_item_check_required": "買取を記録する前に、カードが免税で購入されたものでないことを確認してください",
    "counterparty_address_required": "古物台帳には売主の住所が必要です",
    "shogaku_tokurei_not_available": "この買取には少額の特例は使えません",
    "kobutsu_entries_exist": "この取引はすでに古物台帳に記録されています",
    "kobutsu_correction_invalid": "この訂正は記録できません — 訂正する項目を確認してください",
    "agreement_not_accepted": "委託者に最新の委託契約へ同意してもらう必要があります",
    "intake_not_editable": "この受付はすでに完了または取り消されているため変更できません",
    "intake_empty": "受付を完了する前にカードを1枚以上追加してください",
    "invalid_stage_transition": "今の状態からこのカードをこの状態にはできません",
    "proposal_pending": "このカードの価格変更はすでに返事待ちです",
    "proposal_not_pending": "この価格変更にはすでに返事があります",
    "discount_not_editable": "このカードの割引の可否はもう変更できません",
    "settlement_locked": "この販売の代金はすでに支払い済みです — 調整を使ってください",
    "payout_not_processing": "この支払いはすでに支払い済みか取り消されています",
    "payout_nothing_due": "今この委託者に支払うものはありません",
    "payout_below_minimum": "金額が最低支払額より少ないため、次回の支払いに回ります",
    "payout_allocation_invalid": "支払いがこれらの販売のまだ払っていない額と合いません",
    "payout_proof_required": "支払いの証拠（振込の控えか委託者のサイン）を記録してください",
    "store_credit_customer_required": "ストアクレジットには委託者のお客様アカウントが必要です — 先につなげてください",
    "statement_not_ready": "明細書はまだ準備中です — 少ししてからもう一度お試しください",
    "item_reserved": "今このカードを購入手続き中の人がいます — 今は返却できません",
    "item_not_returnable": "今の状態からはこのカードを返却できません",
    "return_not_editable": "この返却はすでに完了または取り消されています",
    "customer_not_authenticated": "委託中のカードを見るにはログインしてください",
    "read_only_impersonation": "委託者として表示中です — 変更はできません",
    "portal_action_required": "この変更は委託者ページからのみできます",
    "consignor_consent_required": "これには先に委託者の同意が必要です",
    "verification_required": "この変更を確認するため、メールで送ったコードを入力してください",
    "verification_code_invalid": "コードが正しくないか、期限切れです",
    "human_check_required": "ロボットではないことを確認してください",
    "human_check_failed": "ロボット確認に失敗しました — もう一度お試しください",
    "manager_pin_required": "店長のPINが必要です",
    "shift_not_open": "このレジで開いているシフトがありません",
    "register_mismatch": "レジが端末と一致しません",
    "event_schema_invalid": "システム側で問題が発生しました",
    "manifest_invalid": "ネットショップから届いたページ部品の一覧が正しくありません",
    "manifest_version_mismatch": "ページ部品の一覧の版が内容と合いません",
    "manifest_not_found": "ネットショップからページ部品の一覧がまだ届いていません",
    "manifest_missing": "まだウェブサイトを確認できません — ネットショップからページ部品が届いていません",
    "theme_not_found": "デザインが見つかりません",
    "theme_version_not_found": "この公開版はありません",
    "theme_is_live": "公開中のデザインはアーカイブ・削除できません — 先に別のデザインを公開してください",
    "theme_archived": "このデザインはアーカイブされています — 先に元に戻してください",
    "theme_incompatible": "公開する前にウェブサイトの一部を直す必要があります",
    "theme_not_published": "まだデザインが公開されていません",
    "template_not_found": "このページのレイアウトはありません",
    "template_exists": "このページのレイアウトはすでにあります",
    "template_is_base": "ページの種類ごとのメインのレイアウトは削除できません",
    "template_invalid": "ページのレイアウトに問題があります — 一覧を見てください",
    "section_group_invalid": "ヘッダー・フッターに問題があります — 一覧を見てください",
    "policy_required": "法律で必要なページが日本語と英語でまだそろっていません",
    "force_not_allowed": "法定ページが未完成のまま公開できるのはオーナーだけです",
    "preview_expired": "このプレビューリンクは期限切れです",
    "preview_invalid": "このプレビューリンクは正しくありません",
    "preview_token_not_found": "プレビューリンクが見つかりません",
    "handle_taken": "このウェブアドレスは別のページで使われています",
    "page_not_found": "このページはありません",
    "page_trashed": "このページはゴミ箱にあります — 先に元に戻してください",
    "policy_incomplete": "この法定ページの必須項目が日本語か英語で空になっています",
    "policy_not_published": "この法定ページはまだ公開されていません",
    "policy_version_not_found": "この法定ページの版はありません",
    "menu_not_found": "このメニューはありません",
    "menu_item_not_found": "このメニューのリンクはありません",
    "menu_depth_exceeded": "メニューは3階層までです",
    "menu_too_large": "1つのメニューのリンクは最大200件です",
    "menu_cycle": "メニューのリンクを自分自身の中に入れることはできません",
    "menu_in_use": "ウェブサイトでまだこのメニューを表示しています — 先にページのレイアウトから外してください",
    "redirect_not_found": "このウェブアドレスの転送設定はありません",
    "redirect_exists": "このウェブアドレスの転送設定はすでにあります",
    "redirect_invalid": "この転送設定は正しくありません",
    "redirect_loop": "この転送設定だと訪問者がぐるぐる回ってしまいます",
    "redirect_chain_too_long": "転送が続きすぎます — 古いアドレスを最終ページへ直接向けてください",
    "announcement_not_found": "このお知らせはありません",
    "announcement_limit_exceeded": "同時に表示するお知らせが多すぎます — 先に1つ終了するかオフにしてください",
    "locale_not_found": "この言語は店に設定されていません",
    "locale_disabled": "この言語はウェブサイトで提供していません",
    "locale_required": "英語とウェブサイトの基本言語はオフにできません",
    "ui_string_not_found": "このウェブサイトの文言はありません",
    "ui_string_core": "標準のウェブサイト文言は削除できません — 言い回しを変えてください",
    "placeholder_mismatch": "翻訳に英語の文にない {差し込み} が使われています",
    "icu_syntax_invalid": "文の {…} の部分に誤りがあります — かっこを確認してください",
    "translation_invalid": "保存できなかった翻訳があります — 何も変更していません。一覧を見てください",
    "translator_not_configured": "自動翻訳は設定されていません — 翻訳を入力するか、オーナーに相談してください",
    "media_item_not_found": "このファイルはメディアライブラリにありません",
    "media_in_use": "ウェブサイトでまだこのファイルを使っています — 先にこれらの場所で差し替えてください",
    "media_folder_not_found": "このフォルダはありません",
    "media_folder_not_empty": "このフォルダの中にまだフォルダがあります — 先に移動か削除をしてください",
    "media_tag_not_found": "このタグはありません",
    "media_name_taken": "この名前のフォルダかタグはすでにあります",
    "revalidation_not_found": "このウェブサイトの更新はありません",
    "revalidation_in_progress": "このウェブサイトの更新を今送っています — 少しお待ちください",
    "unsupported_format": "このファイルはこのシステムで読めるデザインのバックアップではありません",
    "theme_import_invalid": "デザインのファイルが壊れています — 問題の一覧を見てください",
    "invalid_credentials": "メールアドレスまたはパスワードが正しくありません",
    "account_locked": "失敗が続いたため一時的にロックされました — しばらくしてからお試しください",
    "mfa_code_invalid": "確認コードが正しくありません",
    "password_too_weak": "パスワードが条件を満たしていません",
    "pin_too_weak": "PINは4〜6桁で、よくある並びは使えません",
    "challenge_token_invalid": "このリンクまたはコードは正しくないか、期限切れです",
    "email_already_exists": "このメールアドレスのユーザーはすでにいます",
    "role_in_use": "この役割はまだスタッフに割り当てられています",
    "system_role_protected": "標準の役割は変更・削除できません",
    "last_owner_protected": "有効なオーナーがいなくなってしまうため、できません",
    "unknown_permission": "不明な権限です",
    "pairing_code_invalid": "接続コードが正しくないか、使用済みか、期限切れです",
    "device_revoked": "この端末はもうレジとつながっていません",
    "pin_invalid": "PINが正しくありません",
    "otp_code_invalid": "コードが正しくないか、期限切れです",
    "csrf_token_invalid": "ログインを確認できませんでした — ページを再読み込みしてもう一度お試しください",
    "address_invalid": "住所が正しくありません",
    "too_many_addresses": "住所録がいっぱいです",
    "customer_merge_invalid": "これらのお客様はまとめられません",
    "export_too_large": "書き出す行が多すぎます — 期間や絞り込みを狭めてください",
    "webhook_url_invalid": "この通知先アドレスは使えません"
  }
}
